import { useEffect } from 'react';
import { ToastContainer, toast } from 'react-toastify';

import { sessionStorageService } from 'services/sessionStorage';

import styles from './TranslationWarning.module.scss';

const WarningMessage = () => (
  <p className={`alert-danger text-center ${styles.toastText}`}>
    {translate('Chrome automatic translation feature is not fully supported and might be inaccurate.')}
  </p>
);

const showWarning = () => {
  const translationWarningDisplayed = sessionStorageService.getItem('translationWarningDisplayed');
  if (!translationWarningDisplayed) {
    toast(<WarningMessage />, {
      containerId: 'translation-warning',
    });
    sessionStorageService.translationWarningDisplayed = 'true';
  }
};

export const TranslationWarning = () => {
  useEffect(() => {
    const observer = new MutationObserver(showWarning);
    observer.observe(document.querySelector('html'), {
      attributes: true,
      attributeFilter: ['lang'],
    });
  }, []);
  return (
    <ToastContainer
      toastClassName={`${styles.toast}`}
      position="top-center"
      bodyClassName={`alert alert-danger ${styles.toastBody}`}
      className={`${styles.toastContainer}`}
      draggable={false}
      hideProgressBar
      containerId={'translation-warning'}
      closeButton={false}
      autoClose={false}
      enableMultiContainer
    />
  );
};
